import { render, staticRenderFns } from "./RecordSection.vue?vue&type=template&id=32bd7546&scoped=true&"
import script from "./RecordSection.vue?vue&type=script&lang=tsx&"
export * from "./RecordSection.vue?vue&type=script&lang=tsx&"
import style0 from "./RecordSection.vue?vue&type=style&index=0&id=32bd7546&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bd7546",
  null
  
)

export default component.exports